/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export default {
  ['getCurrentRaceName']: state => state.currentRace.name,
  ['getCurrentRaceId']: state => state.currentRace.id,
  ['getComparesImagesByCurrentRaceId']: (state) => state.currentComparesImages.length ? state.currentComparesImages.filter(image => image.raceId === state.currentRace.id) : [],
  ['getCurrentBaselineComparesImages']: (state) => state.currentBaselineComparesImages.find(image => image.raceId === state.currentRace.id),
  ['getCurrentBaselineComparesImagesAll']: (state) => state.currentBaselineComparesImages,
  ['getIsShowComparesFooter']: (state) => state.isShowComparesFooter,
  ['getOrdered']: (state) => state.ordered,
  columns: state => state.columns,
  columnsDialogVisibility: state => state.columnsDialogVisibility,
  contextMenu: state => state.contextMenu,
  pollingColumns: state => state.pollingImages.columns,
  savedRaces: state => state.savedRaces,
}
